import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { apiCall } from "./calendarUtils";

const FIELDS = [
  ["customer_name", "Name des Kunden"], ["customer_email", "E-Mail"], ["customer_phone", "Telefon"],
  ["player_name", "Name des Spielers (falls abweichend)"], ["training_location", "Trainingsort"],
];

export function EditForm({ token, e, onDone, onCancel }) {
  const [f, setF] = useState({
    customer_name: e.customer?.name || "", customer_email: e.customer?.email || "", customer_phone: e.customer?.phone || "",
    player_name: e.player_name || "", training_location: e.training_location || "", message: e.message || "",
    admin_notes: e.admin_notes || "", player_count: e.player_count || 1,
  });
  const [busy, setBusy] = useState(false);
  const isGroup = e.category === "gruppe";

  const save = async () => {
    setBusy(true);
    try {
      const body = { ...f, player_count: isGroup ? Number(f.player_count) : undefined };
      await apiCall(token, `/calendar/admin/appointments/${e.appointment_id}`, { method: "PATCH", body });
      toast.success("Termindetails gespeichert");
      onDone();
    } catch (err) { toast.error(err.message); }
    setBusy(false);
  };

  return (
    <div className="space-y-3" data-testid="edit-form">
      {FIELDS.map(([k, label]) => (
        <div key={k}>
          <Label className="text-[#A1A1AA] text-xs">{label}</Label>
          <Input value={f[k]} onChange={(ev) => setF({ ...f, [k]: ev.target.value })} className="bg-[#0A0A0A] border-white/20 text-white" data-testid={`edit-${k}`} />
        </div>
      ))}
      {isGroup && (
        <div>
          <Label className="text-[#A1A1AA] text-xs">Teilnehmer</Label>
          <Input type="number" min={1} max={15} value={f.player_count} onChange={(ev) => setF({ ...f, player_count: ev.target.value })} className="bg-[#0A0A0A] border-white/20 text-white" data-testid="edit-player_count" />
        </div>
      )}
      <div>
        <Label className="text-[#A1A1AA] text-xs">Nachricht des Kunden</Label>
        <Textarea value={f.message} onChange={(ev) => setF({ ...f, message: ev.target.value })} rows={2} className="bg-[#0A0A0A] border-white/20 text-white" data-testid="edit-message" />
      </div>
      <div>
        <Label className="text-[#A1A1AA] text-xs">Interne Notiz (nur Admin)</Label>
        <Textarea value={f.admin_notes} onChange={(ev) => setF({ ...f, admin_notes: ev.target.value })} rows={2} className="bg-[#0A0A0A] border-white/20 text-white" data-testid="edit-admin_notes" />
      </div>
      <div className="flex gap-2 justify-end">
        <Button variant="outline" onClick={onCancel} className="border-white/20 text-white rounded-none">Abbrechen</Button>
        <Button onClick={save} disabled={busy} className="bg-[#c1ff72] text-black hover:bg-[#a8e65c] rounded-none" data-testid="edit-save">Speichern</Button>
      </div>
    </div>
  );
}
